import React from "react";

import { WSIcon, WSIconProps } from "../core/WSIcon/WSIcon.component";
import { WSText, WSTextProps } from "../core/WSText/WSText.component";
import { ComponentWithKinds } from "../WSElement/WSElement.helpers";

import styles from "./WSIconList.component.module.scss";
import { WSList, WSListProps } from "../WSList/WSList.component";
import { WSFlexBox } from "../layout";

export const WSIconListKinds = ["Checks"] as const;

type WSIconListKindsType = typeof WSIconListKinds[number];

export interface IconListItem {
  icon: WSIconProps;
  description: React.ReactNode;
}
export interface WSIconListProps extends WSListProps {
  items: (React.ReactNode | IconListItem)[];
  iconProps?: WSIconProps;
  textProps?: WSTextProps;
  inlineIcons?: boolean;
}

const isCustomItem = (
  item: React.ReactNode | IconListItem
): item is IconListItem => {
  return typeof item === "object" && !!item && "description" in item;
};

export const WSIconList: ComponentWithKinds<
  WSIconListProps,
  WSIconListKindsType
> = ({ items, iconProps, textProps, inlineIcons = true, ...otherProps }) => {
  const textPropsInternal = textProps || {
    kind: "Paragraph",
    color: "gray600"
  };
  const iconPropsInternal = iconProps || {
    name: "chevron-right",
    color: "gray600"
  };

  const itemsTemplate = items.map((item, index) => {
    const isCustom = isCustomItem(item);

    const itemIconProps = isCustom ? item.icon : iconPropsInternal;
    const itemText = isCustom ? item.description : item;

    return inlineIcons ? (
      <WSText key={`${index} ${itemText}`} as="span" {...textPropsInternal}>
        <WSIcon className={styles.icon} mr="S" {...itemIconProps} />
        {itemText}
      </WSText>
    ) : (
      <WSFlexBox key={`${index} ${itemText}`} wrap="nowrap">
        <WSIcon className={styles.icon} mr="S" {...itemIconProps} />
        <WSText as="span" {...textPropsInternal}>
          {itemText}
        </WSText>
      </WSFlexBox>
    );
  });

  return (
    <WSList gap="M" {...otherProps}>
      {itemsTemplate}
    </WSList>
  );
};

WSIconList.Checks = (props) => (
  <WSIconList
    iconProps={{
      name: "check",
      color: "green400"
    }}
    textProps={{
      kind: "Paragraph",
      color: "gray600"
    }}
    {...props}
  />
);
